/// <amd-module name="Search/Code/Components/FilterPaneContainer" />

import * as React from "react";
import { css } from "VSS/Platform/Layout";
import * as Container from "Search/Shared/Base/Container";
import { ActionCreator } from "Search/Code/Flux/ActionCreator";
import { StoresHub, IAggregatedState, StoreName } from "Search/Code/Flux/StoresHub"
import { FilterPane } from "Search/Code/Components/FilterPane";

export interface IFilterCotainerProps extends Container.IContainerProps<StoreName, ActionCreator, IAggregatedState, StoresHub> {
    isFullScreen: boolean;
}

export const FilterPaneContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub, IFilterCotainerProps>(
    [
        "filterStore"
    ],
    ({
        filterStoreState,
        searchStoreState,
        isProjectContext
    }, props) => {
        const { filterItemsVisible } = filterStoreState;
        
        return (
            <>
                {
                    filterItemsVisible ? (
                        <div className={css("search-filters-container code-filters-container", props.isFullScreen && "hidden")}>
                            <FilterPane
                                searchStoreState={searchStoreState}
                                filterStoreState={filterStoreState}
                                isProjectContext={isProjectContext}
                                {...props}
                            />
                        </div>
                    ) : null
                }
            </>
        );
    });